import { colors } from 'quasar'
export const hexToRgbA = (hex: string, alpha: string | number) => {
  let c: any
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3)
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]

    c = `0x${c.join('')}`
    const r = (c >> 16) & 255
    const g = (c >> 8) & 255
    const b = c & 255
    return new THREE.Vector4(r / 255, g / 255, b / 255, +alpha)
  }
  throw new Error('Bad Hex')
}

function rgbToYIQ({ r, g, b }) {
  return ((r * 299) + (g * 587) + (b * 114)) / 1000
}

export function generateContrastText(colorHex, threshold = 128) {
  if (colorHex === undefined)
    return '#000'

  const rgb = colors.hexToRgb(colorHex)

  if (rgb === undefined)
    return '#000'

  return rgbToYIQ(rgb) >= threshold ? '#000' : '#fff'
}
